module.exports = __webpack_public_path__ + "static/media/empty-state-signature.6d13fa7b.svg";